<template lang="pug">
  .page
    section
      b-container
        h1 REGISTRATION SUCCESSFUL
        h4 Please follow the confirmation link sent to your email address.
        p Not receiving our email? Please check your spam folder.
        a.text-primary(@click="collapseSendAgain = !collapseSendAgain") RE-SEND CONFIRMATION LINK
        b-collapse(v-model="collapseSendAgain")
          b-form(@submit.prevent="resendConfirmation()")
            .row.pt-3
              .col-md-10
                b-form-input(type="email", required, placeholder="EMAIL", v-model='inputForm.email')
              .col-md-2
                button-load(type="submit", :flag="alert.busy", label="SEND", classes="btn-light")
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { userService } from '@/services';

export default {
  name: 'RegisterOk',
  mixins: [standardMix],
  components: {
  },
  data() {
    return {
      collapseSendAgain: false,
      inputForm: {
        email: '',
      },
    };
  },
  methods: {
    async resendConfirmation() {
      try {
        this.busy();
        await userService.resendConfirmation(this.inputForm.email);
        this.success('Confirmation sent');
        this.collapseSendAgain = false;
      } catch (error) {
        this.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/RegisterOk.vue